//natives
import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

//components
import Table from "../../../../../../../util/Table/.mixins/Table";
import Error from "../../../../../../../util/error/.mixins/Error";

export default function Content(props) {
    return (
        <div className="container">
            {props.state.isLoading &&
                <div align="center">
                    <CircularProgress/>
                </div>
            }
            {!props.state.isLoading && !props.state.isError &&
                <div>
                    <Table {...props}/>
                </div>
            }
            {props.state.isError &&
                <div align="center">
                    <Error text={props.state.error}/>
                </div>
            }
        </div>
    );
}